import {
Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, FormControl, FormLabel, Grid, GridItem, Heading, IconButton, Image, Input, InputGroup, InputLeftElement, Text, Textarea, Tooltip, useDisclosure,} from "@chakra-ui/react";
import { Popover, PopoverTrigger } from "@chakra-ui/react";
import FilterIcon from "../../assets/images/Filter.svg";
import FilterPopover from "../../components/FilterCard/filterCard";
import { AddIcon, EditIcon, SearchIcon } from "@chakra-ui/icons";
import { useEffect, useState } from "react";

import MyDiv from "./docs.style";
import { CustomPagination, CustomTable, CustomToast } from "../../components";
import { Column } from "../../components/CustomTable/customTable";
import { useFetch } from "../../hooks/useFetch";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DocsSchema, IDocsForm } from "./modal";
import { HrlenseInput } from "../../components/Input/Input";
import { showDate } from "../../utilities/helper";
import { Dropdown } from "../../components/DropDown/DropDown";


const Docs = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [docsData, setDocsData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10, });
    const { control, handleSubmit, formState: { errors }, reset, register } = useForm<IDocsForm>({
        resolver: yupResolver(DocsSchema), mode: "onChange", defaultValues: { title: "", description: "", url: "", projectId: 0, type: 0, },
    });
    const [editId, setEditId] = useState<number | null>(null);
    const [projectOptions, setProjectOptions] = useState<any[]>([]);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [selectedFilters, setSelectedFilters] = useState<any>({});

    const onSubmit = async (data: IDocsForm) => {
        setLoading(true);
        const payload: any = {
            title: data.title.trim(),
            description: data.description.trim(),
            url: data.url.trim(),
            projectId: data.projectId,
            type: typeOptions.find(x => x.id === data.type)?.name,
        };
        if (editId) {
            payload["id"] = editId;
        }
        const isDuplicateTitle = docsData.some((doc) => {
            const sameTitle = doc.title?.trim().toLowerCase() === data.title.trim().toLowerCase();

            if (editId) {
                return sameTitle && doc.id !== editId;
            }
            return sameTitle;
        });

        if (isDuplicateTitle) {
            addToast({ message: "Title already exists", status: "warning", });
            setLoading(false);
            return;
        }

        let response;
        if (editId) {
            response = await fetchApi(`Hrlense_Docx/${editId}`, "PUT", payload, null, "Document updated successfully");
        } else {
            response = await fetchApi("Hrlense_Docx", "POST", payload, null, "Document added successfully");
        }

        if (response) {
            await getDocs();
            reset({ title: "", description: "", url: "", projectId: 0, type: 0, });
            setEditId(null);
            onClose();
        }
        setLoading(false);
    };


    const startIndex = lazyParams.page * lazyParams.rows;
    const endIndex = startIndex + lazyParams.rows;
    const paginatedDocs = docsData.slice(startIndex, endIndex);
    const pageCount = Math.ceil(docsData.length / lazyParams.rows);

    const handlePageClick = ({ selected }: { selected: number }) => {
        setLazyParams((prev) => ({ ...prev, page: selected, }));
    };

    const setRowsPerPage = (rows: number) => {
        setLazyParams({ page: 0, rows, });
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [search]);


    useEffect(() => {
        getDocs(debouncedSearch);
    }, [debouncedSearch, selectedFilters]);

    const getDocs = async (search = "") => {
        setLoading(true);
        const params = new URLSearchParams();
        if (search) { params.append("search", search); }
        selectedFilters.Project?.forEach((id: number) => {
            params.append("projectIds", id.toString());
        });

        selectedFilters.Type?.forEach((id: number) => {
            params.append("types", id.toString());
        });

        const query = params.toString();
        const response = await fetchApi("Hrlense_Docx", "GET", null, query);
        if (response) { setDocsData(response); }
        setLoading(false);
    };


    const handleEdit = async (row: any) => {
        await Promise.all([ getDocs(), loadProjectsDropdown()]);
        setEditId(row.id);
        reset({
            title: row.title || "", description: row.description || "",
            url: row.url || "", projectId: row.projectId || 0, type: typeOptions.find((x) => x.name === row.type)?.id || 0,
        });

        onOpen();
    };

    const handleChange = () => {
        setEditId(null);
        reset({ title: "", description: "", url: "", projectId: 0, type: 0, });
        onOpen();
    };

    const loadProjectsDropdown = async () => {
        const response = await fetchApi("Hrlense_Docx/GetProjectsDropdown", "GET");

        if (response) {
            setProjectOptions(response);
        }
    };

    useEffect(() => {
        loadProjectsDropdown();
    }, []);

    const typeOptions = [
        { id: 1, name: "Figma" },
        { id: 2, name: "MsWord" },
        { id: 3, name: "GSheet" },
    ];

    const filterOptions = {
        filterOptions: { Project: projectOptions.map((x) => ({ id: x.id, name: x.name, })),
            Type: typeOptions.map((x) => ({ id: x.id, name: x.name, })),
        },
    };

    return (
        <MyDiv>
            <Box className="page_wrapper">
                <Flex justify="space-between" mb={5} gap={3} >
                    <Heading as="h1" className="font-poppins font_dark text_semibold text_3xl"> Docs  </Heading>

                    <Flex gap={2}>
                        <InputGroup w="200px">
                            <Input placeholder="Search" value={search}
                                onChange={(e) => { setSearch(e.target.value); setLazyParams((prev) => ({ ...prev, page: 0, }));
                                }} bg="white"
                            />
                        </InputGroup>

                        <Popover placement="bottom-end" closeOnBlur>
                            <PopoverTrigger>
                                <Box cursor="pointer"> <Image src={FilterIcon} alt="Filter" boxSize="40px" /> </Box>
                            </PopoverTrigger>

                            <FilterPopover filter={filterOptions} onApplyFilter={(filters) => {
                                    setSelectedFilters(filters);
                                    setLazyParams((prev) => ({ ...prev, page: 0, }));
                                }}
                            />
                        </Popover>
                        <Button bg="#006838" color="white" _hover={{ bg: "#006838" }} px={6} className='font-poppins text_md text_medium' borderRadius="md" onClick={handleChange}>
                            Add Docs
                        </Button>
                    </Flex>
                </Flex>
                <Grid className="grid_container">
                    <GridItem colSpan={12}>
                        <CustomTable value={paginatedDocs} emptyMessage="No documents found" loading={loading}>
                            <Column header="S. No" body={(_, index) => index + 1} />
                            <Column header="Title" field="title" />
                            <Column header="Project" field="projectName" />
                            <Column header="Type" field="type" />
                            <Column header="Description" body={(row: any) => (
                                <Tooltip label={row.description} hasArrow placement="top">
                                    <Text as="span" display="inline-block" maxWidth="9vw" isTruncated> {row.description} </Text>
                                </Tooltip>
                            )} />
                            <Column header="URL" body={(row: any) => (
                                <Text color="#006838" fontWeight="600" textDecoration="underline" cursor="pointer" onClick={() => window.open(row.url, "_blank")}>
                                    View
                                </Text>
                            )} />
                            <Column header="Created By" field="createdBy" />
                            <Column header="Created At" field="created_At" body={(row: any) => showDate(row.created_At)} />
                            {/* <Column header="Updated By" body={(row: any) => row.updatedBy ? row.updatedBy : "-"} />
                            <Column header="Updated At" body={(row: any) => row.updated_At ? showDate(row.updated_At) : "-"} /> */}
                            <Column header="Action" body={(row: any) => (
                                <IconButton aria-label="Edit" icon={<EditIcon />} variant="ghost" size="sm" onClick={() => handleEdit(row)} />
                            )}
                            />
                        </CustomTable>
                    </GridItem>
                </Grid>
            </Box>
            <CustomPagination pageCount={pageCount} rowsPerPageOptions={[10, 20, 50, 100]} handlePageClick={handlePageClick} setRowsPerPage={setRowsPerPage} rowsPerPage={lazyParams.rows} totalRecords={docsData.length} currentPage={lazyParams.page} />
            <Drawer isOpen={isOpen} placement="right" onClose={() => { reset(); onClose(); }} size="md">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">
                        {editId ? "Edit Document" : "Add Document"}
                    </DrawerHeader>

                    <DrawerBody>
                        <form id="docs-form" onSubmit={handleSubmit(onSubmit)}>
                            <Flex direction="column" gap={5} mt={4}>
                                <Dropdown name="projectId" label="Project" control={control} errors={errors} options={projectOptions} valueKey="id" labelKey="name" placeholder="Select Project" isRequired />
                                <Dropdown name="type" label="Type" control={control} errors={errors} options={typeOptions} valueKey="id" labelKey="name" placeholder="Select Type" isRequired />
                                <HrlenseInput isRequired label="Title" name="title" type="text" placeholder="Enter title" control={control} errors={errors} />
                                <FormControl isInvalid={!!errors.description}>
                                    <FormLabel>Description</FormLabel>
                                    <Textarea placeholder="Enter description" {...register("description")} />
                                    {errors.description && (
                                        <Text color="red.500" fontSize="sm" mt={1}> {errors.description.message}  </Text>
                                    )}
                                </FormControl>

                                <HrlenseInput isRequired label="URL" name="url" type="text" placeholder="Enter URL" control={control} errors={errors} />
                            </Flex>
                        </form>
                    </DrawerBody>

                    <DrawerFooter borderTopWidth="1px">
                        <Button variant="outline" mr={3} onClick={() => { reset(); onClose(); }}> Cancel </Button>
                        <Button isLoading={loading} loadingText={editId ? "Updating..." : "Adding..."} bg="#006838" color="white" _hover={{ bg: "#006838" }} type="submit" form="docs-form">
                            {editId ? "Update" : "Add"}
                        </Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </MyDiv>
    );
};

export default Docs;